export const rolesNames = {
  SUPERVISOR: "SUPERVISOR",
  PROJECT_MANAGER: "PROJECT_MANAGER",
  CUSTOMER: "CUSTOMER",
  EDITOR: "EDITOR",
  PROJECT_LEAD: "PROJECT_LEAD",
  PILOT: "PILOT",
  TECHNICIAN: "TECHNICIAN",
};
